<template>
    <fade-left-animation :element="() => $refs.section">
        <section class="blogs-carousel-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <div class="header">
                        <h2 class="title h1">{{ title }}</h2>

                        <b-button
                            variant="primary"
                            class="more-btn d-none d-lg-block"
                            :to="buttonLink"
                        >
                            {{ buttonText }}
                        </b-button>
                    </div>

                    <base-carousel
                        navigation
                        :breakpoints="breakpoints"
                    >
                        <blog-slide-card
                            v-for="(slide, i) in slides"
                            :key="slide.title"
                            :title="slide.title"
                            :thumbnail="slide.thumbnail"
                            :to="slide.to"
                            :slot="`slide_${ slide.title }_${ i }`"
                        />
                    </base-carousel>

                    <div class="actions d-lg-none">
                        <b-button
                            variant="primary"
                            class="more-btn"
                            :to="buttonLink"
                        >
                            {{ buttonText }}
                        </b-button>
                    </div>
                </mobile-gutter>
            </b-container>
        </section>
    </fade-left-animation>
</template>

<script>
    import BaseCarousel from '../../molecules/BaseCarousel/BaseCarousel';
    import BlogSlideCard from '../../molecules/BlogSlideCard/BlogSlideCard';

    export default {
        name: 'blogs-carousel-section',

        components: { BlogSlideCard, BaseCarousel },

        props: {
            title: {
                type: String,
                required: true,
            },

            buttonText: {
                type: String,
                required: true,
            },

            buttonLink: {
                type: String,
                required: true,
            },

            slides: {
                type: Array,
                default: () => ([]),
            },
        },

        computed: {
            /**
             * If there is only 1 slide in the carousel, ensure on mobile it takes up full width.
             *
             * @returns {object}
             */
            breakpoints() {
                if (this.slides.length !== 1) {
                    return {};
                }

                return {
                    0: {
                        slidesPerView: 1,
                    },
                    576: {
                        slidesPerView: 2,
                    },
                    960: {
                        slidesPerView: 3,
                    },
                    1344: {
                        slidesPerView: 4,
                    },
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    ::v-deep {
        @import "~bootstrap/scss/utilities/display";
    }

    .blogs-carousel-section {
        position: relative;
        padding-top: 45px;
        padding-bottom: 45px;
        overflow-x: hidden;

        @include media-breakpoint-up(md) {
            padding-top: 64px;
            padding-bottom: 64px;
        }
    }

    .header {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
        @include media-breakpoint-up(md) {
            margin-bottom: 40px;
            justify-content: space-between;
        }
    }

    .title {
        text-align: center;
        margin-bottom: 0;
        flex-grow: 1;
        @include media-breakpoint-up(lg) {
            text-align: left;
        }
    }

    .actions {
        text-align: center;
        margin-top: 25px;
    }

    .more-btn {
        flex-shrink: 0;
        min-width: 140px;
        @include media-breakpoint-up(lg) {
            margin-left: 50px;
        }
    }
</style>
